import { applyTaxRounding } from "./taxCalculator";

export const toFixed = (num, precision) => {
  return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  );
};

export const toFixedNoRounding = (num, precision) => {
  const re = new RegExp("^-?\\d+(?:.\\d{0," + (precision || -1) + "})?");
  return num.toString().match(re)[0];
};

/**
 * Apply tax rounding - wrapper for backward compatibility
 * This function now uses the centralized applyTaxRounding from taxCalculator
 * @param {string} roundingMode - Rounding mode ('nearest', 'no', 'order_level_distributed')
 * @param {number} tax - Tax amount to round
 * @returns {number} - Rounded tax amount
 *
 * Note: The actual rounding logic is centralized in taxCalculator.js
 * This wrapper maintains backward compatibility with existing code
 */
export const setTaxRound = (roundingMode, tax) => {
  return applyTaxRounding(tax, roundingMode);
};
